<template>
    <b-modal :id="modalId" title="Change stock amount value" centered>
        <div>
            Change amount by:
        </div>
        <small>(if you want to reduce value then insert negative number)</small>

        <div class="row mt-2">
            <div class="form-group col-12">
                <input
                    v-model="by"
                    type="number"
                    class="form-control"
                    dir="auto"
                    :class="{
                        'is-invalid': hasError('by')
                    }"
                />
                <div class="invalid-feedback">
                    {{ getError('by') }}
                </div>
            </div>
        </div>

        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light mr-2"
                    @click="close"
                >
                    Close
                </button>
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    @click="save"
                >
                    Save
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';

export default {
    validations: {
        by: {
            required
        }
    },

    props: {
        modalId: {
            type: String,
            required: false,
            default: 'change-stock-amount-modal'
        },
        title: {
            type: String,
            required: false,
            default: 'Are you sure?'
        },
        itemId: {
            type: String,
            required: true
        },
        actionName: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            by: 0,
            serverErrors: []
        };
    },

    methods: {
        close() {
            this.$bvModal.hide(this.modalId);
        },

        async save() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                const { stockAmount } = await this.$store.dispatch(
                    this.actionName,
                    {
                        id: this.itemId,
                        by: parseInt(this.by)
                    }
                );

                this.$emit('amount-updated', stockAmount);

                this.$toaster('Amount updated!');

                this.$bvModal.hide(this.modalId);
                this.by = 0;
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        hasError(key) {
            return (
                this.$v[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.$v,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
